import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: "https://5cd2c56c0141ef2aee53b47ce9e3d0b8@o813006.ingest.us.sentry.io/4509349123522560",
  integrations: [],
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  tracesSampleRate: 0.1, // Adjust this value in production as needed
  normalizeDepth: 2,
});
